import { cn } from "@/lib/utils";
import * as React from "react";

const DialogHeader: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...props
}) => (
  <div
    className={cn("flex flex-col gap-2 text-center", className)}
    {...props}
  />
);

DialogHeader.displayName = "DialogHeader";

export default DialogHeader;
